import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Link } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    wrap: {
        width: '100%',
        padding: '5px',
        marginTop: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    head: {
        backgroundColor: '#fff',
        border: '2px solid #000',
        borderTopLeftRadius: '20px',
        borderTopRightRadius: '20px',
        borderBottom: 'none',
        backgroundColor: '#C7DFC2',
    },
    parentTop: {
        display: 'flex',
    },
    parentBottom: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    childImage: {
        width: '30%',
        marginRight: '10px',
        marginLeft: '20px',
        position: 'relative'
    },
    personImage: {
        width:  '90px',
        verticalAlign: 'bottom',
        position: 'absolute',
        top: '-42px'
    },
    childTitleWrap: {
        width: '100%',
        marginTop: '10px',
        marginRight: '10px'
    },
    childTitle: {
        marginTop: '10px',
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#007c00',
        textAlign: 'center'
    },
    child: {
        fontSize: '14px',
        paddingLeft: '3%',
        paddingRight: '3%'
    },
    childFooter: {
        paddingTop: '10px',
        paddingBottom: '5px',
        border: '2px solid #000',
        borderTop: 'none',
        borderBottomLeftRadius: '20px',
        borderBottomRightRadius: '20px',
    },
}));

// 説明
function GuideHead(props){
    const classes = useStyles();

    return(
        <div className={classes.wrap}>
            <div className={classes.head}>
                <div className={classes.childTitle}>
                    自筆証書遺言・財産目録が簡単に作成できます
                </div>
            </div>
            <div className={classes.childFooter}>
                <div className={classes.parentBottom}>
                    <div className={classes.childImage}>
                        <img src="img/person.png" className={classes.personImage} />
                    </div>
                    <div className={classes.childTitleWrap}>
                        <div className={classes.child}>
                            このサイトでは、ご自身で無料で自筆証書遺言と財産目録をかんたんに作成できます。<br />
                            なお、弁護士にしっかり相談して作成したい場合は、気軽に相談する事も可能です。
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GuideHead
